const _ = require("lodash");
const GradeChapter = require("../../../shared/GradeChapter");
const OpsLab = require("../../lab/vault/OpsLab");

const isValidLabBlock = function(labBlockID) {
	const allLabBlockIDs = OpsLab.getAllBlockIDs();
	return _.includes(allLabBlockIDs, labBlockID);
};

const isValidReportPageData = function(pageData) {
	const {grade, chapter, typeID, labBlockID} = pageData;
	const activeGrades = GradeChapter.getActiveGrades();
	const allTypeIDs = OpsLab.getAllTypeIDs();
	const activeSpaces = ["lab"];
	if (
		(grade && !_.includes(activeGrades.concat(activeSpaces), grade)) ||
		(chapter && !GradeChapter.isValidChapterNumber(chapter)) ||
		(grade === "lab" && typeID && !_.includes(allTypeIDs, typeID)) ||
		(grade === "lab" && labBlockID && !isValidLabBlock(labBlockID))
	) {
		return false;
	}
	return true;
};

module.exports = {
	isValidReportPageData,
};
